import { motion } from 'framer-motion';

import { cn } from './cn';

export interface TagBadgeProps {
  text: string;
  /** Native browser tooltip; defaults to `text`. Pass an empty string to suppress it (e.g. when wrapped in a custom Tooltip). */
  title?: string;
  className?: string;
}

export const TagBadge = ({ text, title, className }: TagBadgeProps) => (
  <motion.span
    title={title ?? text}
    className={cn(
      'inline-flex items-center rounded-full bg-gray-200 px-2.5 py-0.5 text-xs leading-4 text-gray-700 whitespace-nowrap overflow-hidden text-ellipsis h-6 mr-1',
      className
    )}
    initial={{ opacity: 0, scale: 0.9 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.2 }}
    whileHover={{ scale: 1.05 }}
  >
    {text}
  </motion.span>
);

export interface TagListProps {
  tags: Array<{ key: string; text: string }>;
  maxVisible?: number;
  className?: string;
}

export const TagList = ({ tags, maxVisible = 2, className }: TagListProps) => (
  <div className={cn('flex flex-nowrap overflow-hidden min-h-7 items-center gap-0.5', className)}>
    {tags.map((tag, index, array) => {
      if (index < maxVisible) {
        return <TagBadge key={tag.key} text={tag.text} />;
      } else if (index === maxVisible) {
        const remaining = array.length - maxVisible;
        return (
          <TagBadge
            key="more-tags"
            text={`+${remaining}`}
            title={`+${remaining} more ${remaining === 1 ? 'tag' : 'tags'}`}
          />
        );
      }
      return null;
    })}
  </div>
);
